import { useEffect } from 'react';
import { Alert, Form, Input, Modal } from 'antd';
import { REQUEST_TYPES, type DataSubjectRequest } from './api';

interface RejectRequestModalProps {
  request: DataSubjectRequest | null;
  submitting: boolean;
  onSubmit: (reason: string) => void;
  onCancel: () => void;
}

/**
 * Từ chối một yêu cầu.
 *
 * Luật cho phép từ chối nhưng **bắt buộc nêu lý do**, và lý do đó là thứ khách được biết.
 * Vì vậy ô này bắt buộc và server cũng kiểm lại — client chỉ báo sớm.
 */
export function RejectRequestModal({
  request,
  submitting,
  onSubmit,
  onCancel,
}: RejectRequestModalProps) {
  const [form] = Form.useForm<{ reason: string }>();

  useEffect(() => {
    if (request) form.setFieldsValue({ reason: '' });
  }, [request, form]);

  return (
    <Modal
      open={request !== null}
      title={request ? `Từ chối: ${REQUEST_TYPES[request.type].label} — ${request.memberCode}` : ''}
      okText="Từ chối yêu cầu"
      okButtonProps={{ danger: true }}
      cancelText="Hủy"
      confirmLoading={submitting}
      onCancel={onCancel}
      destroyOnHidden
      onOk={() => {
        form
          .validateFields()
          .then((values) => onSubmit(values.reason.trim()))
          .catch(() => {});
      }}
    >
      {request && (
        <>
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}
            message="Lý do từ chối sẽ được trả lời cho khách"
            description="Luật cho phép từ chối, nhưng bắt buộc giải thích. Viết như đang nói với khách, không phải ghi chú nội bộ."
          />

          <Form form={form} layout="vertical" requiredMark={false}>
            <Form.Item
              name="reason"
              label="Lý do từ chối"
              rules={[
                { required: true, message: 'Từ chối yêu cầu phải nêu lý do.' },
                { max: 1000, message: 'Lý do quá dài.' },
              ]}
            >
              <Input.TextArea
                rows={3}
                placeholder="Không xác minh được yêu cầu đến từ chủ tài khoản. Đã liên hệ số điện thoại đăng ký ngày 09/08 nhưng không nhận được phản hồi."
              />
            </Form.Item>
          </Form>
        </>
      )}
    </Modal>
  );
}
